<template>
  <kds2-pop kind="menu" role="menu" above :anchor="anchor" :label="tx('menu.status', { id: t.id })" @close="$emit('close')">
    <template v-for="item in items">
      <div v-if="item.sep" :key="'sep-' + item.key" class="k2-psep" role="separator"></div>
      <button
        :key="item.key"
        type="button"
        role="menuitem"
        :class="{ 'k2-mi--bad': item.bad, 'is-cur': item.key === cur }"
        :aria-current="item.key === cur ? 'true' : null"
        :data-fk="'ms-' + item.key"
        @click="onPick(item)"
      >
        <k2-icon :n="item.icon" :s="20" /><span>{{ item.text }}</span>
        <k2-icon v-if="item.key === cur" n="mdi-check" :s="20" class="k2-mi-ck" />
      </button>
    </template>
  </kds2-pop>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import Kds2Pop from "./Kds2Pop.vue";
import kds2Text from "@/mixins/kds2Text";
import { menuState } from "@/utils/guestOrderStatus";

// Meni uz strelicu na glavnom dugmetu kartice: bilo koje stanje jednim dodirom, za narudžbe koje su ostale od ranije
// ili im niko nije promijenio stanje. Trenutno stanje je označeno. Isti koraci kao u detaljima narudžbe.
export default {
  name: "Kds2StatusMenu",
  components: { K2Icon, Kds2Pop },
  mixins: [kds2Text],
  props: {
    t: { type: Object, required: true },
    anchor: { default: null },
  },
  computed: {
    // stanje na koje se odnosi označeni red: "u pripremi" je i accepted i in-progress
    cur() {
      const state = menuState(this.t.state);
      return state === "in-progress" ? "accepted" : state;
    },
    items() {
      return [
        { key: "on-hold", icon: "mdi-receipt-text-outline", text: this.$t("kds_new_orders") },
        { key: "accepted", icon: "mdi-pot-steam-outline", text: this.$t("in-progress") },
        { key: "ready", icon: "mdi-food-takeout-box-outline", text: this.$t("ready") },
        { key: "delivered", icon: "mdi-truck-check", text: this.$t("delivered") },
        { key: "completed", icon: "mdi-check-all", text: this.$t("completed"), sep: true },
        { key: "cancelled", icon: "mdi-cancel", text: this.$t("cancelled"), bad: true },
        { key: "rejected", icon: "mdi-close-circle-outline", text: this.tx("state.rejected"), bad: true },
      ];
    },
  },
  methods: {
    onPick(item) {
      if (item.key === this.cur) {
        this.$emit("close");
        return;
      }
      this.$emit("pick", item.key);
    },
  },
};
</script>
